import { usePerms } from 'contexts/PermsContext';
import 'pages/Dashboard/assets/Dashboard.css';
import React from 'react';
import RolePage from '../RoleManager';

const TAB_OPTIONS = ['Role Details', 'Permissions', 'Dashboard View'];

export default function ViewRole(): JSX.Element {
  const perms = usePerms();

  const headerOptions = [
    { option: 'Role Details' },
    { option: 'Permissions' },
    ...(perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewAsRole'])
      ? [{ option: 'Dashboard View' }]
      : []),
  ];

  return (
    <RolePage
      mode="view"
      tabOptions={TAB_OPTIONS}
      tabHeaderOptions={headerOptions}
      leftFirstLabel="Return"
      rightLabel="Next"
      rightFinalLabel="Return"
    />
  );
}
